import { RootState } from '@/shared/store'

import { constraintsAdapter } from './constraintsAdapter'

export const constraintsSelectors = constraintsAdapter.getSelectors<RootState>(
  (state) => state.constraints,
)
